'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _common = require('../../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseFundingsNewButton = (0, _classAutobindDecorator2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseFundingsNewButton, _Component);

  function CaseFundingsNewButton() {
    _classCallCheck(this, CaseFundingsNewButton);

    return _possibleConstructorReturn(this, (CaseFundingsNewButton.__proto__ || Object.getPrototypeOf(CaseFundingsNewButton)).apply(this, arguments));
  }

  _createClass(CaseFundingsNewButton, [{
    key: 'onClick',
    value: function onClick() {
      this.props.onClick(this.props.lienType.model);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bsStyle = _props.bsStyle,
          lienType = _props.lienType,
          buttonProps = bsStyle ? { bsStyle: bsStyle } : { bsSize: 'small' },
          icon = (0, _get3.default)(lienType, 'icon', 'file-o'),
          buttonText = lienType.label ? 'New ' + lienType.label + ' Lien' : 'New Lien';


      return _react2.default.createElement(
        _Button2.default,
        _extends({}, buttonProps, {
          onClick: this.onClick }),
        _react2.default.createElement(_common.Icon, { type: icon }),
        ' ',
        buttonText
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseFundingsNewButton;
}(_react.Component), _class2.propTypes = {
  bsStyle: _propTypes2.default.string,
  lienType: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func.isRequired
}, _temp)) || _class;

var _default = CaseFundingsNewButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseFundingsNewButton, 'CaseFundingsNewButton', '/app/src/components/page-case/main-fundings/CaseFundingsNewButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-fundings/CaseFundingsNewButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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